import React, { useState } from 'react'
import { CloseIcon } from '../../../assets/icons/close-icon-simple'
import AddPatient from './patient-sidebar/add-patient'
import EditPatient from './patient-sidebar/edit-patient'
import FileUpload from './bulk-upload/file-upload'


const Sidebar = ({ closeModel, patientDetails, addToastMessage }) => {

    const [activeTab, setActiveTab] = useState('Individual')

    return (
        <div className="text-center w-[570px]  bg-white h-full">
            <div className="border-b border-[#B2ACC9] w-full" style={{ borderColor: 'rgb(200, 214, 230)' }}>
                <div className="flex justify-between items-center w-full px-5 py-6">
                    <h2 className="font-semibold text-left">{patientDetails?.patientID ? "Edit Patient" : "Add Patient"} </h2>
                    <button onClick={() => { closeModel(); }}><CloseIcon /> </button>
                </div>
            </div>

            <div className="flex flex-col h-[calc(100vh-150px)] py-8">
                {!patientDetails?.patientID && (<>
                    <div className="px-8 pb-0">
                        <div className="flex cursor-pointer mb-[30px]">
                            <div
                                style={{ color: activeTab === 'Individual' ? '#245CEA' : '#1A1A1B' }}
                                className="text-[15px] text-center font-medium font-mont w-full"
                                onClick={() => setActiveTab('Individual')}
                            >
                                <span className='px-5'>Individual</span>
                                {activeTab === 'Individual' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                            </div>

                            <div style={{ color: activeTab === 'Bulk Upload' ? '#245CEA' : '#1A1A1B', }}
                                className="text-[15px] text-center font-medium  font-mont w-full"
                                onClick={() => setActiveTab('Bulk Upload')} >
                                <span className='px-5'>Bulk Upload</span>
                                {activeTab === 'Bulk Upload' ? <div className="border-b border-4 h-1 relative top-2 z-10 rounded-sm" style={{ borderColor: "#245CEA" }}></div> : <div className=" h-1 border-b border-4 relative top-2 z-10 rounded-sm" style={{ borderColor: "#C8D6E6" }}></div>}
                            </div>
                        </div>
                    </div>
                </>)}

                {activeTab === "Individual" ? (<>
                    <div className={`p-8 pb-0 pt-0 overflow-y-auto ${patientDetails?.patientID ? "h-[calc(100vh-340px)]" : "h-[calc(100vh-430px)]"} `}>
                        <div className="text-left ">
                            {patientDetails?.patientID ?
                                <EditPatient
                                    closeModel={closeModel}
                                    addToastMessage={addToastMessage}
                                    id={patientDetails?.patientID} /> :
                                <AddPatient
                                    addToastMessage={addToastMessage}
                                    closeModel={closeModel} />}
                        </div>
                    </div>
                </>) : (<>
                    <div className={`p-8 pb-0 pt-0 overflow-y-auto ${patientDetails?.patientID ? "h-[calc(100vh-340px)]" : "h-[calc(100vh-430px)]"} `}>
                        <div className="text-left">
                            <FileUpload 
                                closeModel={closeModel}
                                addToastMessage={addToastMessage} />
                        </div>
                    </div>
                </>)}
            </div>
        </div>
    )
}

export default Sidebar